/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

export default (visualizationType :any, hasSummary :boolean) :boolean => {

    const { name } = visualizationType;

    return hasSummary || name === 'Crosstab' || name === 'Table';
};
